import OriginTracing from '@atlassiansox/origin-tracing';

import { isProduction, getIdentityBaseUrl } from '@/utils/urls';

export type SocialProvider = 'google' | 'microsoft' | 'apple' | 'slack';

export function getLoginOrigin(provider: string): string {
	const metadataId = `wac-signup-${provider}`;
	const originTracingOptions: { product: string; id?: string } = {
		product: metadataId,
	};

	if (isProduction()) {
		originTracingOptions.id = 'static-uuid-for-testing';
	}

	const loginOrigin = new OriginTracing({ ...originTracingOptions });
	return loginOrigin.encode();
}

export function getSocialButtonUrl({
	redirectTo,
	identityCobranding,
	provider,
}: {
	redirectTo: string;
	identityCobranding: string;
	provider: string;
}) {
	const continueUrl = new URL(redirectTo);

	continueUrl.searchParams.append('social-signup-login', 'true');

	const params = new URLSearchParams({
		application: identityCobranding,
		continue: continueUrl.href,
		prompt: 'select_account',
		atlOrigin: encodeURIComponent(getLoginOrigin(provider)),
	});

	return `${getIdentityBaseUrl()}/login/initiate/${provider}?${params}`;
}
